import { OrgContext } from "contexts/OrgContext";
import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { classNames } from "components/utils";
import OrgResourceLimits from "./OrgResourceLimits";
import { isOrgAdminOrMaintainerRole } from "utils/roleUtils";

interface LocationState {
  segment?: string;
}

const OrgPageSettings: React.FC = () => {
  const { state } = useLocation<LocationState>();
  const orgContext = useContext(OrgContext);

  const billingRef = React.useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    document.title = "Organization Settings | Brev.dev";
    if (state?.segment === "billing") {
      billingRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  if (
    orgContext.activeOrg &&
    isOrgAdminOrMaintainerRole(orgContext.activeOrgRole)
  ) {
    return (
      <div className="flex flex-col justify-evenly items-center">
        <div
          className={classNames(
            "flex mt-3 flex-col justify-start items-start w-full",
          )}
        >
          <OrgResourceLimits />
        </div>
      </div>
    );
  }
  // when clicking the settings button, reponse time is so fast the seeing loading bars feels off
  return <div />;
};

export default OrgPageSettings;
